module.exports = __webpack_public_path__ + "img/logo-start.217fa149.png";